// extracted by mini-css-extract-plugin
export default {"rightAlignedButton":"rightAlignedButton---BWHyP","alertDetails":"alertDetails---vhf7v","lastRow":"lastRow---kLk8r"};